
import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import HeaderLogo from "../structure/headerlogo";
import CommonIcon from '../common/customicon';


const FinancialForecasting = () => {
  const forecastChartRef = useRef(null);
  const brandForecastRef = useRef(null);

  useEffect(() => {
    // Forecast Chart
    if (forecastChartRef.current) {
      new Chart(forecastChartRef.current, {
        type: "line",
        data: {
          labels: ['Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Jan 27','Feb 27','Mar 27'],
          datasets: [
            {label:'Forecasted Revenue', data:[290,310,325,340,330,345,360,320,310,350,365,375], borderColor:'#3B82F6', backgroundColor:'rgba(59,130,246,0.1)', fill:true, tension:0.3},
            {label:'Guaranteed Minimum', data:[57,57,57,57,57,57,57,57,57,57,57,57], borderColor:'#10B981', borderDash:[5,5], pointRadius:0},
            {label:'Best Case', data:[330,355,375,390,380,400,415,370,360,405,420,435], borderColor:'#8B5CF6', borderDash:[3,3], pointRadius:0, backgroundColor:'rgba(139,92,246,0.05)', fill:true},
            {label:'Historical (Last Year)', data:[245,260,270,280,275,290,300,270,265,285,295,310], borderColor:'#9CA3AF', borderDash:[2,4], pointRadius:0}
          ]
        },
        options: { responsive:true, scales:{y:{title:{display:true,text:'Revenue ($K)'}}} }
      });
    }
    // Brand Forecast
    if (brandForecastRef.current) {
      new Chart(brandForecastRef.current, {
        type: 'doughnut',
        data: {
          labels: ['Aurora Animation','Midnight Echo','StarBlaze Heroes'],
          datasets: [{data:[1950,850,1020], backgroundColor:['#3B82F6','#8B5CF6','#F97316']}]
        },
        options: { responsive:true, plugins:{legend:{position:'bottom'}} }
      });
    }
  }, []);

  return (
    <div className="main-content" style={{ paddingTop: 64 }}>
      <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height"></div>
          <div className="bg-gray-50 min-h-screen">
            <div className=" ">
        <div className="flex items-center justify-between mb-6">
          <div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="TrendingUp" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                <h1 className="h3 mb-0 fw-bold">Financial Forecasting</h1>
                <p className="text-muted mb-0 small">Project royalty revenue based on contract terms and historical sales</p>
              </div>
</div>  

          {/* <div>
            <h1 className="text-3xl font-bold text-gray-900">Financial Forecasting</h1>
            <p className="text-gray-500 mt-1">Project royalty revenue based on contract terms and historical sales</p>
          </div> */}
          <div className="flex gap-2">
            <select className="border rounded-lg px-4 py-2 bg-white">
              <option>All Brands</option>
              <option>Aurora Animation</option>
              <option>Midnight Echo</option>
            </select>
            <select className="border rounded-lg px-4 py-2 bg-white">
              <option>12-month forecast</option>
              <option>6-month forecast</option>
              <option>24-month forecast</option>
            </select>
            <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">Export Forecast</button>
          </div>
        </div>

        {/* Forecast Summary */}
        <div className="grid grid-cols-4 gap-4 mb-6">
          <div className="bg-white rounded-xl shadow p-2 border-l-4 border-blue-500">
            <p className="text-sm text-gray-500">Forecasted Revenue (12M)</p>
            <p className="text-2xl font-bold">$3.82M</p>
            <p className="text-sm text-green-600">+18% vs trailing 12M</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2 border-l-4 border-green-500">
            <p className="text-sm text-gray-500">Guaranteed Minimum</p>
            <p className="text-2xl font-bold">$685K</p>
            <p className="text-sm text-gray-400">Floor revenue from all contracts</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2 border-l-4 border-purple-500">
            <p className="text-sm text-gray-500">Best Case Scenario</p>
            <p className="text-2xl font-bold text-purple-700">$4.5M</p>
            <p className="text-sm text-purple-500">+15% growth assumption</p>
          </div>
          <div className="bg-white rounded-xl shadow p-2 border-l-4 border-orange-500">
            <p className="text-sm text-gray-500">At-Risk Revenue</p>
            <p className="text-2xl font-bold text-orange-600">$420K</p>
            <p className="text-sm text-orange-500">3 contracts expiring, no renewal yet</p>
          </div>
        </div>

        {/* Main Forecast Chart */}
        <div className="bg-white rounded-xl shadow p-6 mb-6">
          <h5 className="text-lg font-semibold mb-4">Revenue Forecast — Next 12 Months</h5>
          <canvas ref={forecastChartRef} height="120"></canvas>
        </div>

        <div className="grid grid-cols-2 gap-6 mb-6">
          {/* By Brand */}
          <div className="bg-white rounded-xl shadow p-6">
            <h5 className="text-lg font-semibold mb-4">Forecast by Brand</h5>
            <canvas ref={brandForecastRef} height="200"></canvas>
          </div>

          {/* Scenario Analysis */}
          <div className="bg-white rounded-xl shadow p-6">
            <h5 className="text-lg font-semibold mb-4">Scenario Analysis</h5>
            <div className="space-y-4">
              <div className="p-4 bg-green-50 rounded-lg border border-green-200">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-green-800">Best Case (+15% growth)</p>
                    <p className="text-sm text-green-600">All renewals confirmed, new licensees onboarded</p>
                  </div>
                  <p className="text-2xl font-bold text-green-700">$4.5M</p>
                </div>
                <div className="w-full bg-green-200 rounded-full h-3 mt-2"><div className="bg-green-600 h-3 rounded-full" style={{width:'100%'}}></div></div>
              </div>
              <div className="p-4 bg-blue-50 rounded-lg border border-blue-200">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-blue-800">Base Case (Current trend)</p>
                    <p className="text-sm text-blue-600">Historical growth rate maintained, existing portfolio</p>
                  </div>
                  <p className="text-2xl font-bold text-blue-700">$3.82M</p>
                </div>
                <div className="w-full bg-blue-200 rounded-full h-3 mt-2"><div className="bg-blue-600 h-3 rounded-full" style={{width:'85%'}}></div></div>
              </div>
              <div className="p-4 bg-yellow-50 rounded-lg border border-yellow-200">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-yellow-800">Conservative (-10%)</p>
                    <p className="text-sm text-yellow-600">Economic slowdown, some licensee underperformance</p>
                  </div>
                  <p className="text-2xl font-bold text-yellow-700">$2.9M</p>
                </div>
                <div className="w-full bg-yellow-200 rounded-full h-3 mt-2"><div className="bg-yellow-600 h-3 rounded-full" style={{width:'64%'}}></div></div>
              </div>
              <div className="p-4 bg-red-50 rounded-lg border border-red-200">
                <div className="flex justify-between items-center">
                  <div>
                    <p className="font-semibold text-red-800">Worst Case (Expiring contracts lost)</p>
                    <p className="text-sm text-red-600">3 expiring contracts not renewed + market decline</p>
                  </div>
                  <p className="text-2xl font-bold text-red-700">$2.1M</p>
                </div>
                <div className="w-full bg-red-200 rounded-full h-3 mt-2"><div className="bg-red-600 h-3 rounded-full" style={{width:'47%'}}></div></div>
              </div>
            </div>
          </div>
        </div>

        {/* Contract-level Forecast */}
        <div className="bg-white rounded-xl shadow p-6">
          <h5 className="text-lg font-semibold mb-4">Contract-Level Revenue Forecast</h5>
          <div className="overflow-x-auto">
            <table className="w-full text-sm min-w-[700px]">
              <thead className="bg-gray-50">
                <tr>
                  <th className="p-3 text-left">Licensee</th>
                  <th className="p-3 text-left">Brand</th>
                  <th className="p-3 text-right">Last 12M Actual</th>
                  <th className="p-3 text-right">Next 12M Forecast</th>
                  <th className="p-3 text-right">Growth</th>
                  <th className="p-3 text-center">Confidence</th>
                  <th className="p-3 text-center">Risk</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-t"><td className="p-3 font-medium">Summit Ridge Merch</td><td className="p-3">Aurora Animation</td><td className="p-3 text-right">$228,000</td><td className="p-3 text-right font-semibold">$262,200</td><td className="p-3 text-right text-green-600">+15%</td><td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">High</span></td><td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Low</span></td></tr>
                <tr className="border-t"><td className="p-3 font-medium">Golden State Apparel</td><td className="p-3">Aurora Animation</td><td className="p-3 text-right">$238,000</td><td className="p-3 text-right font-semibold">$273,700</td><td className="p-3 text-right text-green-600">+15%</td><td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">High</span></td><td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Low</span></td></tr>
                <tr className="border-t"><td className="p-3 font-medium">Dreamlight Studios</td><td className="p-3">StarBlaze Heroes</td><td className="p-3 text-right">$189,000</td><td className="p-3 text-right font-semibold">$208,000</td><td className="p-3 text-right text-green-600">+10%</td><td className="p-3 text-center"><span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded text-xs">Medium</span></td><td className="p-3 text-center"><span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded text-xs">Medium</span></td></tr>
                <tr className="border-t"><td className="p-3 font-medium">Horizon Peak Retail</td><td className="p-3">Midnight Echo</td><td className="p-3 text-right">$120,000</td><td className="p-3 text-right font-semibold">$132,000</td><td className="p-3 text-right text-green-600">+10%</td><td className="p-3 text-center"><span className="bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded text-xs">Medium</span></td><td className="p-3 text-center"><span className="bg-green-100 text-green-700 px-2 py-0.5 rounded text-xs">Low</span></td></tr>
                <tr className="border-t bg-red-50"><td className="p-3 font-medium">Bright Star Retail</td><td className="p-3">Aurora Animation</td><td className="p-3 text-right">$95,000</td><td className="p-3 text-right font-semibold text-red-600">$0 — $95,000</td><td className="p-3 text-right text-red-600">At Risk</td><td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs">Low</span></td><td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs">Expiring</span></td></tr>
                <tr className="border-t bg-red-50"><td className="p-3 font-medium">Pacific Coast Toys</td><td className="p-3">StarBlaze Heroes</td><td className="p-3 text-right">$45,000</td><td className="p-3 text-right font-semibold text-red-600">$0 — $45,000</td><td className="p-3 text-right text-red-600">At Risk</td><td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs">Low</span></td><td className="p-3 text-center"><span className="bg-red-100 text-red-700 px-2 py-0.5 rounded text-xs">Expiring</span></td></tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div></div></div></div>
  );
};

export default FinancialForecasting;
